import type { OutlookFavoriteServiceDataType } from 'owa-favorites-types';
import type CategoryType from 'owa-service/lib/contract/CategoryType';
import type { MailFolder } from 'owa-graph-schema';
import { getEffectiveFolderDisplayName } from 'owa-folders';
import { convertEWSFolderIdToRestFolderId } from '../utils/ewsRestFolderIdConverter';

export function createOwsFavoriteCategoryData(
    category: CategoryType,
    isMigration: boolean
): OutlookFavoriteServiceDataType {
    return {
        Type: 'category', // VSO 26094: Replace the custom string with server defined supported type
        DisplayName: category.Name,
        SingleValueSettings: [
            {
                Key: 'CategoryId',
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (20,17): Type 'string | undefined' is not assignable to type 'string'.
                // @ts-expect-error
                Value: category.Id,
            },
        ],
        Client: isMigration ? 'Migration' : 'OWA', // VSO 26094: Replace the custom string with server defined supported type
    };
}

export function createOwsFavoriteFolderData(
    folder: MailFolder,
    isMigration: boolean,
    newIndex?: number
): OutlookFavoriteServiceDataType {
    return {
        Type: 'folder',
        DisplayName: getEffectiveFolderDisplayName(folder),
        SingleValueSettings: [
            {
                Key: 'FolderId',
                Value: convertEWSFolderIdToRestFolderId(folder.id),
            },
            {
                Key: 'ChangeKey',
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (45,17): Type 'Maybe<string> | undefined' is not assignable to type 'string'.
                // @ts-expect-error
                Value: folder.changeKey,
            },
        ],
        Client: isMigration ? 'Migration' : 'OWA',
        Index: newIndex,
    };
}
